// extracted by mini-css-extract-plugin
module.exports = {"container":"MxF0ePkk","text":"_QXqU8cd","useDash":"n_IXNMNW"};